
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index74tUkbx7x8b6PFMdA9H6UrdP6t7QDUx2J_2QpXc6e3YMeta } from "/app/pages/index/index.vue?macro=true";
import { default as compatqTKRvTS2HSo9rplyXto4MRtiM_ntrnT35bGl7f7kcGYMeta } from "/app/pages/compat.vue?macro=true";
import { default as forecastoSTkTvv4W20qsWa6Mb21CrIGdigkr6HvIB0Cb57UHsgMeta } from "/app/pages/forecast.vue?macro=true";
import { default as _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta } from "/app/pages/news/[id].vue?macro=true";
import { default as join06PAfu6efM4A5hD6WSHsltmCaq3pB5gbvysvUvZSGMcMeta } from "/app/pages/about/join.vue?macro=true";
import { default as caseMpmsGOroRvAPO6P3WII43fuT18MbH5AWOm4bTkd0fFYMeta } from "/app/pages/media/case.vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as brandiIVSuuIhdaIo3WpYJTvAbbFiLMokezwnbj4YjqDlfu0Meta } from "/app/pages/about/brand.vue?macro=true";
import { default as indexsziV31bRWzCkX_45YudaBOdqrwcbympIP9GPi2Nu0StJUMeta } from "/app/pages/about/index.vue?macro=true";
import { default as indexlSNdvCx53ceijxGjnFCXR4lUUkYXBZYqWh4knUdwegYMeta } from "/app/pages/media/index.vue?macro=true";
import { default as VIPWtQ9TGLskLIYRao7zonToK3CT3UPVD22Dbd06AXpUAUMeta } from "/app/pages/weather/VIP.vue?macro=true";
import { default as indexjzm98OL8ih7w8l4vG452J1aM4s0mZ0vcSJmfFydywsUMeta } from "/app/pages/search/index.vue?macro=true";
import { default as historyeL1lXtS9ZZSkuGxCrZfoY8ngDejQsAVpZPDIVNl5AZ8Meta } from "/app/pages/about/history.vue?macro=true";
import { default as indexqquBsVoqzZ9PtPOUjB5ScDMJIeZPv5XI7tvmkXNjguMMeta } from "/app/pages/contact/index.vue?macro=true";
import { default as indexCe37QYFxBbR3danwfrk_45s5eCwvsL3vPQpWwWLpOaUm8Meta } from "/app/pages/weather/index.vue?macro=true";
import { default as _91id_93vypOQigjycRYgiwtvTp4lUcin_45Scz_rkQB4i1CUO7voMeta } from "/app/pages/weathernews/[id].vue?macro=true";
import { default as indexZBd_45nGVufJOPJvPXSnkU1JXo90kTPlhKxTYxM25bu6wMeta } from "/app/pages/weather/APP/index.vue?macro=true";
import { default as indexIgOSsj_rhPx4g_45N7C6jWQQ1xAeG48EM5h4MxLDWuOjwMeta } from "/app/pages/weathernews/index.vue?macro=true";
import { default as PopularScenesoAiZqKbzDkve4SsxxuriHIkDKa87zV8jhAxe81bFklgMeta } from "/app/pages/weather/PopularScenes.vue?macro=true";
import { default as MojiWeatherAPPMBFQPFvRqERDNEBpts6LCJF8hKOlHSSt14Xzp_dQrA0Meta } from "/app/pages/weather/MojiWeatherAPP.vue?macro=true";
import { default as MojiWeatherVIPChhV_TAAig8CMi_45OX0yy0RT8k7Bk6Lf9SbXmVgGjvyQMeta } from "/app/pages/weather/MojiWeatherVIP.vue?macro=true";
import { default as otherDownloadkri___45es65Y_4521aCMrflVsZkjmyDumeuROephmq3MewMeta } from "/app/pages/weather/APP/otherDownload.vue?macro=true";
import { default as component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta } from "/app/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.35_cac@6.7._07bfedff0c1c82e81e14dd9d7a28cad8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M } from "/app/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.35_cac@6.7._07bfedff0c1c82e81e14dd9d7a28cad8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index/index.vue")
  },
  {
    name: "compat___zh-CN",
    path: "/zh-CN/compat",
    meta: compatqTKRvTS2HSo9rplyXto4MRtiM_ntrnT35bGl7f7kcGYMeta || {},
    component: () => import("/app/pages/compat.vue")
  },
  {
    name: "compat___en-US",
    path: "/en-US/compat",
    meta: compatqTKRvTS2HSo9rplyXto4MRtiM_ntrnT35bGl7f7kcGYMeta || {},
    component: () => import("/app/pages/compat.vue")
  },
  {
    name: "forecast___zh-CN",
    path: "/zh-CN/forecast",
    component: () => import("/app/pages/forecast.vue")
  },
  {
    name: "forecast___en-US",
    path: "/en-US/forecast",
    component: () => import("/app/pages/forecast.vue")
  },
  {
    name: "news-id___zh-CN",
    path: "/zh-CN/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___en-US",
    path: "/en-US/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "about-join___zh-CN",
    path: "/zh-CN/about/join",
    component: () => import("/app/pages/about/join.vue")
  },
  {
    name: "about-join___en-US",
    path: "/en-US/about/join",
    component: () => import("/app/pages/about/join.vue")
  },
  {
    name: "media-case___zh-CN",
    path: "/zh-CN/media/case",
    component: () => import("/app/pages/media/case.vue")
  },
  {
    name: "media-case___en-US",
    path: "/en-US/media/case",
    component: () => import("/app/pages/media/case.vue")
  },
  {
    name: "news___zh-CN",
    path: "/zh-CN/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___en-US",
    path: "/en-US/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "about-brand___zh-CN",
    path: "/zh-CN/about/brand",
    component: () => import("/app/pages/about/brand.vue")
  },
  {
    name: "about-brand___en-US",
    path: "/en-US/about/brand",
    component: () => import("/app/pages/about/brand.vue")
  },
  {
    name: "about___zh-CN",
    path: "/zh-CN/about",
    component: () => import("/app/pages/about/index.vue")
  },
  {
    name: "about___en-US",
    path: "/en-US/about",
    component: () => import("/app/pages/about/index.vue")
  },
  {
    name: "index___zh-CN",
    path: "/zh-CN",
    component: () => import("/app/pages/index/index.vue")
  },
  {
    name: "index___en-US",
    path: "/en-US",
    component: () => import("/app/pages/index/index.vue")
  },
  {
    name: "media___zh-CN",
    path: "/zh-CN/media",
    component: () => import("/app/pages/media/index.vue")
  },
  {
    name: "media___en-US",
    path: "/en-US/media",
    component: () => import("/app/pages/media/index.vue")
  },
  {
    name: "weather-VIP___zh-CN",
    path: "/zh-CN/weather/VIP",
    component: () => import("/app/pages/weather/VIP.vue")
  },
  {
    name: "weather-VIP___en-US",
    path: "/en-US/weather/VIP",
    component: () => import("/app/pages/weather/VIP.vue")
  },
  {
    name: "search___zh-CN",
    path: "/zh-CN/search",
    component: () => import("/app/pages/search/index.vue")
  },
  {
    name: "search___en-US",
    path: "/en-US/search",
    component: () => import("/app/pages/search/index.vue")
  },
  {
    name: "about-history___zh-CN",
    path: "/zh-CN/about/history",
    component: () => import("/app/pages/about/history.vue")
  },
  {
    name: "about-history___en-US",
    path: "/en-US/about/history",
    component: () => import("/app/pages/about/history.vue")
  },
  {
    name: "contact___zh-CN",
    path: "/zh-CN/contact",
    component: () => import("/app/pages/contact/index.vue")
  },
  {
    name: "contact___en-US",
    path: "/en-US/contact",
    component: () => import("/app/pages/contact/index.vue")
  },
  {
    name: "weather___zh-CN",
    path: "/zh-CN/weather",
    component: () => import("/app/pages/weather/index.vue")
  },
  {
    name: "weather___en-US",
    path: "/en-US/weather",
    component: () => import("/app/pages/weather/index.vue")
  },
  {
    name: "weathernews-id___zh-CN",
    path: "/zh-CN/weathernews/:id()",
    component: () => import("/app/pages/weathernews/[id].vue")
  },
  {
    name: "weathernews-id___en-US",
    path: "/en-US/weathernews/:id()",
    component: () => import("/app/pages/weathernews/[id].vue")
  },
  {
    name: "weather-APP___zh-CN",
    path: "/zh-CN/weather/APP",
    component: () => import("/app/pages/weather/APP/index.vue")
  },
  {
    name: "weather-APP___en-US",
    path: "/en-US/weather/APP",
    component: () => import("/app/pages/weather/APP/index.vue")
  },
  {
    name: "weathernews___zh-CN",
    path: "/zh-CN/weathernews",
    component: () => import("/app/pages/weathernews/index.vue")
  },
  {
    name: "weathernews___en-US",
    path: "/en-US/weathernews",
    component: () => import("/app/pages/weathernews/index.vue")
  },
  {
    name: "weather-PopularScenes___zh-CN",
    path: "/zh-CN/weather/PopularScenes",
    component: () => import("/app/pages/weather/PopularScenes.vue")
  },
  {
    name: "weather-PopularScenes___en-US",
    path: "/en-US/weather/PopularScenes",
    component: () => import("/app/pages/weather/PopularScenes.vue")
  },
  {
    name: "weather-MojiWeatherAPP___zh-CN",
    path: "/zh-CN/weather/MojiWeatherAPP",
    component: () => import("/app/pages/weather/MojiWeatherAPP.vue")
  },
  {
    name: "weather-MojiWeatherAPP___en-US",
    path: "/en-US/weather/MojiWeatherAPP",
    component: () => import("/app/pages/weather/MojiWeatherAPP.vue")
  },
  {
    name: "weather-MojiWeatherVIP___zh-CN",
    path: "/zh-CN/weather/MojiWeatherVIP",
    component: () => import("/app/pages/weather/MojiWeatherVIP.vue")
  },
  {
    name: "weather-MojiWeatherVIP___en-US",
    path: "/en-US/weather/MojiWeatherVIP",
    component: () => import("/app/pages/weather/MojiWeatherVIP.vue")
  },
  {
    name: "weather-APP-otherDownload___zh-CN",
    path: "/zh-CN/weather/APP/otherDownload",
    component: () => import("/app/pages/weather/APP/otherDownload.vue")
  },
  {
    name: "weather-APP-otherDownload___en-US",
    path: "/en-US/weather/APP/otherDownload",
    component: () => import("/app/pages/weather/APP/otherDownload.vue")
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/mjsoft/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/mjsoft/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/mjsoft",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/mjsoft/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/mjsoft/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/agreement/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/agreement/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/agreement",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/agreement/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/agreement/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/updata/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/updata/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/updata",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/updata/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/updata/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/faq/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/faq/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/faq",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/faq/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/faq/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/index.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/index.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/index.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/index.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/about/culture/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/about/culture/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/culture",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/about/culture/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/about/culture/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/news/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/news/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/news/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/news/index.html",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/android_down.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/android_down.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/android_down.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/android_down.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/en-US/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/en-US/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/en-US/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/en-US/weather",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/weather/china",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/weather/china",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/weather/china/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/weather/china/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/weather/china",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/weather/china",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/weather/china/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/weather/china/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/weather/world",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/weather/world",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/weather/world/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/weather/world/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/weather/world",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/weather/world",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/weather/world/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/weather/world/:pathMatch(.*)",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/zh-CN/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/zh-CN/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/en-US/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/en-US/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/en-US/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/en-US/forecast",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/images/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/images/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/images/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/images/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/waphelp",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/waphelp/index_new.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/waphelp/index_new.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/waphelp/index.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/waphelp/index.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/waphelp/qa_new.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/waphelp/qa_new.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/zh-CN/waphelp/qa.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  },
  {
    name: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5MMeta?.name,
    path: "/en-US/waphelp/qa.php",
    component: component_45stubJk3lZLPKGeLZHLedkYNyTA6MV2_45E62eHATkv0bbiT5M
  }
]